import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { InfoComponent } from '../info/info.component';
import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent implements OnInit {
  infoComponent = InfoComponent;
  notificationsComponent = NotificationsComponent;
  active = false;
  infoActive = false;
  notificationsActive = false;

  constructor() {}

  ngOnInit(): void {}

  handleClick() {
    this.active = !this.active;
  }
}
